export default "__VITE_ASSET__Ds5BSBfK__"